module.exports = __webpack_public_path__ + "static/img/wrj4.a7e18006.png";